import React, {Component} from 'react'
import CInput from '@/components/CForm/CInput'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { postLogin,loginPhone,fixToken,selecttype,loginout} from "@/servers/commonApi";
import { setStorage} from "@/utils";
import { withRouter} from 'react-router-dom'
import {setUserInfo, setUserList} from "../../redux/common/action";
import { connect} from 'react-redux'
import { bindActionCreators, compose} from 'redux'
import './index.scss'
import Time from './components/count'
import {Modal, message,ConfigProvider} from "antd";
import zhCN from 'antd/es/locale/zh_CN';


@CBaseComponent
class Login extends Component{

  onRef(ref){this.child = ref}

  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.changHandler = this.changHandler.bind(this);
    this.changHandler1 = this.changHandler1.bind(this);
    this.changHandler2 = this.changHandler2.bind(this);
    this.onChange = this.onChange.bind(this)
    this.modalOk1 = this.modalOk1.bind(this);
    this.modalCancel1= this.modalCancel1.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.downloadFile = this.downloadFile.bind(this)
  }


  state = {
    mobile:'',
    vcode:'',
    loginid: '',
    password: '',
    type: 'phone',
    isModalOpen: false,
    userlist: [],
    checked:false,
    modal1: {
      visible: false,
    },
    mobiles:'',
    vcodes:'',
    mid:''
  };

  changHandler(value, type){
    this.setState({
      [type]: value
    })
  }

  changHandler2(value){
    this.setState({
      mobiles:value
    })
  }

  changHandler1(value){
    this.setState({
      vcodes:value
    })
  }

  //切换登录方式
  changlogintype(data){
    this.setState({
      type:data,
      mobile:'',
      vcode:'',
      name:'',
      password: ''
    })
  }
  getToken(){
    fixToken().then(res=>{
    })
  }

  modalOk1(){
    if(!this.state.mobiles){
      message.error('请输入登录的手机号码');
      return
    }
    const reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!reg.test(this.state.mobiles)) {
      message.error('请输入正确的手机号码');
      return
    }

    if(!this.state.vcodes){
      message.error('请输入手机验证码');
      return
    }
    const data = {
      mobile:this.state.mobiles,
      vcode:this.state.vcodes,
      mid:this.state.mid,
    }
    loginPhone(data).then(res=>{
      if(res.statecode === 0) {
        let userInfo = res.records;
        setStorage('userInfo', userInfo);
        this.props.setUserInfo(userInfo);
        if (userInfo[0].clerklist.length > 1) {
          this.setState({
            isModalOpen: true,
            userlist:userInfo[0].clerklist
          })
        } else if (userInfo[0].clerklist.length === 1) {
          this.selectPersonType(userInfo[0].clerklist[0].id,userInfo[0].clerklist[0].clerklevel)
        } else {
          message.error('该用户暂无角色无法登陆');
          this.handleCancel()
        }
      } else {
        message.error(res.statemessage);
      }
    })
  }

  modalCancel1(){
    this.setState({
      modal1: {...this.state.modal1, visible: false},
      mobiles:'',
      vcodes:''
    })
  }


  login(){
    if(!this.state.loginid || !this.state.password){
      message.error('请完善登录信息');
      return
    }
    const data = {
      loginid:this.state.loginid,
      password:this.state.password
    }
    postLogin(data).then(res=>{
      if(res.statecode === 0) {
        let userInfo = res.records;
        setStorage('userInfo', userInfo);
        this.props.setUserInfo(userInfo);
        if (userInfo[0].clerklist.length > 1) {
          this.setState({
            isModalOpen: true,
            userlist:userInfo[0].clerklist
          })
        } else if (userInfo[0].clerklist.length === 1) {
          this.selectPersonType(userInfo[0].clerklist[0].id,userInfo[0].clerklist[0].clerklevel)
        } else {
          message.error('该用户暂无角色无法登陆');
          this.handleCancel()
        }
      }  else if(res.statecode === 108) {
        this.setState({
          modal1: {...this.state.modal1, visible: true},
          mid:res.statemessage
        })
      } else {
        message.error(res.statemessage);
      }
    })
  }

  gotozn(){
    window.open('/fc/down/7.博物馆运行评估信息系统使用指南.pdf','_blank')
  }

  loginphone(){
    if(!this.state.mobile){
      message.error('请输入登录的手机号码');
      return
    }
    const reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!reg.test(this.state.mobile)) {
      message.error('请输入正确的手机号码');
      return
    }

    if(!this.state.vcode){
      message.error('请输入手机验证码');
      return
    }
    const data = {
      mobile:this.state.mobile,
      vcode:this.state.vcode
    }
    loginPhone(data).then(res=>{
      if(res.statecode === 0) {
        let userInfo = res.records;
        setStorage('userInfo', userInfo);
        this.props.setUserInfo(userInfo);
        if (userInfo[0].clerklist.length > 1) {
          this.setState({
            isModalOpen: true,
            userlist:userInfo[0].clerklist
          })
        } else if (userInfo[0].clerklist.length === 1) {
          this.selectPersonType(userInfo[0].clerklist[0].id,userInfo[0].clerklist[0].clerklevel)
        } else {
          message.error('该用户暂无角色无法登陆');
          this.handleCancel()
        }
      } else {
        message.error(res.statemessage);
      }
    })
  }

  selectPersonType(data,type){
    selecttype({uid:data}).then(res=>{
      if (res.statecode !== 0) {
        message.error(res.statemessage)
      } else {
        let userInfo = res.records[0];
        setStorage('userList', userInfo);
        this.props.setUserList(userInfo);
        setStorage('login', true)
        if (type == 8 || type == 9) {
          this.props.history.push({
            pathname: '/home',
          });
          window.location.reload(true)
        } else if (type == 3 || type == 4 || type == 16) {
          this.props.history.push({
            pathname: '/homeCentral',
          });
          window.location.reload(true)
        } else if (type == 10 || type == 11) {
          this.props.history.push({
            pathname: '/homeScore',
          });
          window.location.reload(true)
        } else {
          this.props.history.push({
            pathname: '/homeProvince',
          });
          window.location.reload(true)
        }
      }
    }).catch((err)=>{
      console.log(err);
    })
  }


  handleCancel(){
    this.setState({
      isModalOpen: false,
    })
    loginout().then(res=>{
      if (res.statecode === 0) {
        // 退出
        setStorage('userInfo', null);
        this.props.setUserInfo(null);
        setStorage('userList', null);
        this.props.setUserList(null);
      } else {
        message.error(res.statemessage);
      }
    })
  }

  menuClick(data){
    const d = {
      uid:data
    }
    selecttype(d).then(res=>{
      if (res.statecode !== 0) {
        message.error(res.statemessage);
      } else {
      let userInfo = res.records[0];
      setStorage('userList', userInfo);
      this.props.setUserList(userInfo);
      setStorage('login', true)
      if (userInfo.clerklevel == 8 || userInfo.clerklevel == 9) {
              this.props.history.push({
                pathname: '/home',
              });
        window.location.reload(true)
      } else if (userInfo.clerklevel == 3 || userInfo.clerklevel == 4) {
              this.props.history.push({
                pathname: '/homeCentral',
              });
        window.location.reload(true)
      } else if (userInfo.clerklevel == 10) {
              this.props.history.push({
                pathname: '/homeScore',
              });
        window.location.reload(true)
      } else {
        this.props.history.push({
          pathname: '/homeProvince',
        });
        window.location.reload(true)
      }
      }
    })
  }

  onChange(){
    this.setState({
      checked: !this.state.checked
    })
  }

  downloadFile(){
    window.location.href='/fc/down/常见问题解答汇总.pdf'
  }


  componentDidMount(){
      this.getToken()
  }

  render(){
    return (
     <ConfigProvider locale={zhCN}>
      <div className='login' >
        <div className='login-title'>
          博物馆运行评估系统
        </div>
        <div className='flex login-content'>
          {/*<div className='login-icon'>*/}
          {/*  <img src={url} alt=""/>*/}
          {/*</div>*/}
          <div className='login-form'>
            <div className='flex login-form-title'>
              <div className='login-form-title-name'>
                <span className={this.state.type==='phone'?'activeted':'normal'} onClick={() => this.changlogintype('phone')} style={{color:this.state.type === 'phone'?'#000000':''}}>手机登录</span>
                <span style={{margin:'0 20px'}}>|</span>
                <span className={this.state.type==='count'?'activeted':'normal'} onClick={() => this.changlogintype('count')} style={{color:this.state.type === 'count'?'#000000':''}}>账号登录</span>
              </div>
              <i className='fa fa-edit'></i>
            </div>
            <div className='login-form-content'>
              {this.state.type === 'count'?<div>
                <CInput value={this.state.loginid} placeholder='请输入用户名' onChange={(value) => this.changHandler(value, 'loginid')} onEnter={this.login} />
                <CInput type='password' value={this.state.password} placeholder='请输入密码' onChange={(value) => this.changHandler(value, 'password')} onEnter={this.login} />
                <CButton className='login-button' size='larger' block type='primary' onClick={this.login}>登 录</CButton>
                <div style={{textAlign:'center'}}>
                  如果遇到使用问题,请阅读<span style={{color:'#3c8dbc',cursor:'pointer'}}>使用指南</span><span style={{color:'#3c8dbc',cursor:'pointer',marginLeft:'10px'}} onClick={this.downloadFile}>常见问题</span>
                </div>
              </div>:
              <div>
                  <CInput value={this.state.mobile} placeholder='请输入手机号'  onChange={(value)=>this.changHandler(value, 'mobile')}/>
                <div className='phone-block'>
                  <CInput value={this.state.vcode} placeholder='请输入验证码' onChange={(value) => this.changHandler(value, 'vcode')} onEnter={this.login} />
                  <Time seconds={60} mobile={this.state.mobile} />
                </div>
                <CButton className='login-button' size='larger' block type='primary' onClick={()=>this.loginphone()}>登 录</CButton>
                <div style={{textAlign: 'center'}}>
                  如果遇到使用问题,请阅读 <span style={{color: '#3c8dbc', cursor: 'pointer'}} onClick={() => {
                  this.gotozn()
                }}>使用指南</span><span style={{color:'#3c8dbc',cursor:'pointer',marginLeft:'10px'}} onClick={this.downloadFile}>常见问题</span>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        <div className='login-footer'>
          技术支持电话：15801346528&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;评估办公室邮箱：bwgpg@boxie.org.cn
        </div>
        <Modal title="请选择登录的角色"
               visible={this.state.isModalOpen}
               onCancel={this.handleCancel}
               footer={[]}
        >
            <div className='loginlist'>
              {
                this.state.userlist.map((item, index)=>
                <span onClick={() => this.menuClick(item.id)}>{item.realname}</span>
                )
              }
            </div>

        </Modal>
        <Modal
            visible={this.state.modal1.visible}
            onOk={this.modalOk1}
            onCancel={this.modalCancel1}
            closable={false}
        >
          <div>
            <CInput value={this.state.mobiles} placeholder='请输入手机号'  onChange={(value)=>this.changHandler2(value)}/>
            <div className='phone-block'>
              <CInput value={this.state.vcodes} placeholder='请输入验证码' onChange={(value) => this.changHandler1(value)} />
              <Time seconds={60} mobile={this.state.mobiles} />
            </div>
          </div>
        </Modal>
      </div>
        </ConfigProvider>
    )
  }
}


const mapStateToProps = (state) => {
  return {}
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUserInfo: bindActionCreators(setUserInfo, dispatch),
    setUserList:bindActionCreators(setUserList,dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Login);
